var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "el-card",
        { staticClass: "box-card-class c1", attrs: { shadow: "never" } },
        [
          _c(
            "el-row",
            {
              staticStyle: {
                "justify-content": "space-between",
                "align-items": "center",
                "flex-wrap": "wrap",
              },
              attrs: { type: "flex" },
            },
            [
              _c("el-col", { attrs: { span: 6 } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "letter-spacing": "2px",
                      "font-size": "20px",
                      color: "#0F172A",
                      "font-weight": "600",
                    },
                  },
                  [_vm._v("运输看板")]
                ),
                _c(
                  "div",
                  { staticStyle: { "font-size": "14px", color: "#A8AEB9" } },
                  [_vm._v("Atualizado(Horário de Brasília)")]
                ),
              ]),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        "text-align": "right",
                        "padding-right": "20px",
                        "box-sizing": "border-box",
                      },
                      attrs: { span: 12 },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "inline-block",
                            "text-align": "center",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "custom-radio-group",
                              attrs: { size: "mini" },
                              model: {
                                value: _vm.dateRadio,
                                callback: function ($$v) {
                                  _vm.dateRadio = $$v
                                },
                                expression: "dateRadio",
                              },
                            },
                            [
                              _c(
                                "el-radio-button",
                                { attrs: { label: "yesterday" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("collectionCenter.yesterday"))
                                  ),
                                ]
                              ),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "today" } },
                                [_vm._v(_vm._s(_vm.$t("newOrder.today")))]
                              ),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "month" } },
                                [_vm._v(_vm._s(_vm.$t("newOrder.thisMonth")))]
                              ),
                              _c(
                                "el-radio-button",
                                { attrs: { label: "lastMonth" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("collectionCenter.lastMonth"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("br"),
                          _c("el-date-picker", {
                            staticClass: "dateClass",
                            attrs: {
                              type: "daterange",
                              "value-format": "yyyy-MM-dd",
                              "end-placeholder": _vm.$t(
                                "collectionCenter.EndTime"
                              ),
                              "range-separator": "~",
                              "start-placeholder": _vm.$t(
                                "collectionCenter.StartTime"
                              ),
                              size: "mini",
                              clearable: false,
                            },
                            on: { change: _vm.dateChange },
                            model: {
                              value: _vm.timeVal,
                              callback: function ($$v) {
                                _vm.timeVal = $$v
                              },
                              expression: "timeVal",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-col",
                    { staticClass: "regionSteteClass", attrs: { span: 12 } },
                    [
                      _c(
                        "el-col",
                        { staticClass: "dividerClass", attrs: { span: 8 } },
                        [
                          _c("div", { staticClass: "searchClass" }, [
                            _vm._v("大区 Área"),
                          ]),
                          _c("ElSelectV2", {
                            staticStyle: { width: "90%" },
                            attrs: {
                              options: _vm.regionList,
                              placeholder: _vm.$t("placeOrder.pleaseChoose"),
                              clearable: "",
                              filterable: "",
                              multiple: "",
                              "collapse-tags": "",
                              size: "mini",
                              "popper-class": "SelectV2_popper",
                            },
                            on: { change: _vm.changeRegion },
                            model: {
                              value: _vm.queryForm.params.areaNameList,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "areaNameList",
                                  $$v
                                )
                              },
                              expression: "queryForm.params.areaNameList",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "dividerClass", attrs: { span: 8 } },
                        [
                          _c("div", { staticClass: "searchClass" }, [
                            _vm._v("州 Estado"),
                          ]),
                          _c("ElSelectV2", {
                            staticStyle: { width: "90%" },
                            attrs: {
                              options: _vm.stateList,
                              placeholder: _vm.$t("placeOrder.pleaseChoose"),
                              clearable: "",
                              filterable: "",
                              multiple: "",
                              "collapse-tags": "",
                              size: "mini",
                              "popper-class": "SelectV2_popper",
                            },
                            on: { change: _vm.changeState },
                            model: {
                              value: _vm.queryForm.params.stateList,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm.params, "stateList", $$v)
                              },
                              expression: "queryForm.params.stateList",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("div", { staticClass: "searchClass" }, [
                            _vm._v("转运中心 HUB"),
                          ]),
                          _c("ElSelectV2", {
                            staticStyle: { width: "90%" },
                            attrs: {
                              options: _vm.transitCenterOptions,
                              placeholder: _vm.$t("placeOrder.pleaseChoose"),
                              clearable: "",
                              filterable: "",
                              multiple: "",
                              "collapse-tags": "",
                              size: "mini",
                              "popper-class": "SelectV2_popper",
                            },
                            model: {
                              value: _vm.queryForm.params.departmentList,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "departmentList",
                                  $$v
                                )
                              },
                              expression: "queryForm.params.departmentList",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("div", {
                        staticClass: "el-icon-search searchBtn",
                        on: { click: _vm.search },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.updateTime,
                  expression: "updateTime",
                },
              ],
              staticClass: "update_time_class",
            },
            [_vm._v("数据更新时间(北京时间)：" + _vm._s(_vm.updateTime))]
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card-class c2", attrs: { shadow: "never" } },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.queryForm.params.dataType,
                callback: function ($$v) {
                  _vm.$set(_vm.queryForm.params, "dataType", $$v)
                },
                expression: "queryForm.params.dataType",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: "揽收运输 Coleta e transp", name: "揽收运输" },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: "干线运输 Transporte de linha",
                  name: "干线运输",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: "支线运输 Transporte Alimentador",
                  name: "支线运输",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card-class", attrs: { shadow: "never" } },
        [
          _c("span", { staticClass: "redClass" }, [_vm._v("客户 Cliente")]),
          _c(
            "el-select",
            {
              attrs: {
                filterable: "",
                clearable: "",
                multiple: "",
                "collapse-tags": "",
                remote: "",
                "reserve-keyword": "",
                "remote-method": _vm.getCustomerPage,
                placeholder: _vm.$t("spareNumberPoo.Only20AreDisplayed"),
              },
              on: {
                clear: function ($event) {
                  return _vm.getCustomerPage("")
                },
              },
              model: {
                value: _vm.queryForm.params.customerNameList,
                callback: function ($$v) {
                  _vm.$set(_vm.queryForm.params, "customerNameList", $$v)
                },
                expression: "queryForm.params.customerNameList",
              },
            },
            _vm._l(_vm.customerList, function (item, ind) {
              return _c("el-option", {
                key: ind,
                attrs: {
                  label: item.customerAlias + "(" + item.username + ")",
                  value: item.username,
                },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card-class c4", attrs: { shadow: "never" } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    "border-right": "1px solid #E6EAED",
                    "box-sizing": "border-box",
                    width: "60%",
                    position: "relative",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-upload2 uploadClass",
                    on: {
                      click: function ($event) {
                        return _vm.exportThis(1)
                      },
                    },
                  }),
                  _c("div", { staticClass: "card-title-class" }, [
                    _vm._v("装卸车辆数据监控 Monitor Veículos"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "data-monitoring-container" },
                    _vm._l(
                      _vm.groupedVehicleDataList,
                      function (row, rowIndex) {
                        return _c(
                          "div",
                          { key: rowIndex, staticClass: "data-card-wrapper" },
                          _vm._l(row, function (item, index) {
                            return _c(
                              "el-col",
                              { key: index, staticClass: "data-card" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "corner-decoration" },
                                  [
                                    _c("div", {
                                      class: [
                                        "corner-rectangle",
                                        "style-" + (rowIndex * 3 + index + 1),
                                      ],
                                    }),
                                    _c("div", {
                                      class: [
                                        "corner-square",
                                        "style-" + (rowIndex * 3 + index + 1),
                                      ],
                                    }),
                                    index !== 2
                                      ? _c("i", {
                                          class: [
                                            "corner-icon",
                                            "style-" +
                                              (rowIndex * 3 + index + 1),
                                            "el-icon-truck",
                                          ],
                                        })
                                      : _c("i", {
                                          class: [
                                            "corner-icon",
                                            "style-" +
                                              (rowIndex * 3 + index + 1),
                                            "el-icon-warning-outline",
                                          ],
                                        }),
                                  ]
                                ),
                                _c("div", { staticClass: "data-label" }, [
                                  _vm._v(_vm._s(item.label)),
                                ]),
                                _c("div", { staticClass: "data-value" }, [
                                  _vm._v(_vm._s(item.value)),
                                ]),
                              ]
                            )
                          }),
                          1
                        )
                      }
                    ),
                    0
                  ),
                ]
              ),
              _c(
                "el-col",
                { staticStyle: { width: "40%", position: "relative" } },
                [
                  _c("i", {
                    staticClass: "el-icon-upload2 uploadClass",
                    on: {
                      click: function ($event) {
                        return _vm.exportThis(2)
                      },
                    },
                  }),
                  _c("div", { staticClass: "card-title-class" }, [
                    _vm._v("看板运输装载情况 Status de Carga"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "data-monitoring-container" },
                    _vm._l(
                      _vm.groupedTransportDataList,
                      function (row, rowIndex) {
                        return _c(
                          "div",
                          {
                            key: rowIndex,
                            staticClass: "data-card-wrapper",
                            style: {
                              justifyContent:
                                rowIndex === 1 ? "flex-start" : "space-between",
                            },
                          },
                          _vm._l(row, function (item, index) {
                            return _c(
                              "el-col",
                              {
                                key: index,
                                staticClass: "data-card",
                                style: {
                                  flex:
                                    rowIndex === 1 && index === 0
                                      ? "0 0 calc(50% - 5px)"
                                      : "1",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "corner-decoration" },
                                  [
                                    _c("div", {
                                      class: ["corner-rectangle", "style-11"],
                                    }),
                                    _c("div", {
                                      class: ["corner-square", "style-22"],
                                    }),
                                    _c("i", {
                                      class: [
                                        "corner-icon",
                                        "style-" +
                                          (rowIndex === 0 && index === 0
                                            ? "33"
                                            : "44"),
                                        "el-icon-truck",
                                      ],
                                    }),
                                  ]
                                ),
                                _c("div", { staticClass: "data-label" }, [
                                  _vm._v(_vm._s(item.label)),
                                ]),
                                _c("div", { staticClass: "data-value" }, [
                                  _vm._v(_vm._s(item.value)),
                                ]),
                              ]
                            )
                          }),
                          1
                        )
                      }
                    ),
                    0
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        {
          staticStyle: {
            "justify-content": "space-between",
            "align-items": "flex-start",
            gap: "10px",
          },
          attrs: { type: "flex" },
        },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-card",
                {
                  staticClass: "box-card-class",
                  staticStyle: { position: "relative" },
                  attrs: { shadow: "never" },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-upload2 uploadClass u3",
                    on: {
                      click: function ($event) {
                        return _vm.exportThis(3)
                      },
                    },
                  }),
                  _c("div", { staticClass: "card-title-class last" }, [
                    _vm._v("到车准点监控 Monitor de Chegada no Horário"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "arrival-monitoring-content" },
                    [
                      _c("div", { staticClass: "info-section" }, [
                        _c("span", { staticClass: "info-label left" }, [
                          _vm._v(_vm._s(_vm.arrivalRate)),
                        ]),
                        _c("span", { staticClass: "info-detail" }, [
                          _c("span", [_vm._v("到车准点率")]),
                          _c("br"),
                          _c("span", [_vm._v("Taxa de Chegada no Horário")]),
                        ]),
                      ]),
                      _c(
                        "el-table",
                        {
                          staticClass: "arrival-table",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.arrivalTableData,
                            border: "",
                            "max-height": "600",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "dimFlow", label: "来向Fluxo" },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "exceptArrivalTime",
                              label: "预计到车时间Prev. Chegada",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "actualArrivalTime",
                              label: "实际到车时间Chegada Real",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "timeoutDuration",
                              label: "超时时长Duração Estouro(h)",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        style:
                                          scope.row.timeoutDuration > 0
                                            ? "color: red"
                                            : "color: green",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.timeoutDuration
                                                ? scope.row.timeoutDuration +
                                                    "H"
                                                : "--"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c("el-pagination", {
                        staticStyle: { margin: "10px 0", float: "right" },
                        attrs: {
                          "current-page": _vm.ArrivalForm.pageNumber,
                          "page-size": _vm.ArrivalForm.pageSize,
                          "page-sizes": [10, 20, 50, 100],
                          total: _vm.ArrivalForm.total,
                          background: "",
                          layout: "total, sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "size-change": _vm.handleArrivalMonitor1,
                          "current-change": _vm.handleArrivalMonitor,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-card",
                {
                  staticClass: "box-card-class",
                  staticStyle: { position: "relative" },
                  attrs: { shadow: "never" },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-upload2 uploadClass u4",
                    on: {
                      click: function ($event) {
                        return _vm.exportThis(4)
                      },
                    },
                  }),
                  _c("div", { staticClass: "card-title-class last" }, [
                    _vm._v("发车准点监控 Monitor Partida no Horário"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "arrival-monitoring-content" },
                    [
                      _c("div", { staticClass: "info-section" }, [
                        _c("span", { staticClass: "info-label right" }, [
                          _vm._v(_vm._s(_vm.departRate)),
                        ]),
                        _c("span", { staticClass: "info-detail" }, [
                          _c("span", [_vm._v("发车及时率")]),
                          _c("br"),
                          _c("span", [_vm._v("Taxa Partida no Horário")]),
                        ]),
                      ]),
                      _c(
                        "el-table",
                        {
                          staticClass: "arrival-table",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.departTableData,
                            border: "",
                            "max-height": "600",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "dimFlow", label: "流向Fluxo" },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "exceptDepartTime",
                              label: "预计发车时间Prev. Partida",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "actualDepartTime",
                              label: "实际发车时间Partida Real",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "timeoutDuration",
                              label: "超时时长Duração Estouro(h)",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        style:
                                          scope.row.timeoutDuration > 0
                                            ? "color: red"
                                            : "color: green",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.timeoutDuration
                                                ? scope.row.timeoutDuration +
                                                    "H"
                                                : "--"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c("el-pagination", {
                        staticStyle: { margin: "10px 0", float: "right" },
                        attrs: {
                          "current-page": _vm.departForm.pageNumber,
                          "page-size": _vm.departForm.pageSize,
                          "page-sizes": [10, 20, 50, 100],
                          total: _vm.departForm.total,
                          background: "",
                          layout: "total, sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "size-change": _vm.handleDepartMonitor1,
                          "current-change": _vm.handleDepartMonitor,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }